import React from "react";
import Skeleton from "react-loading-skeleton";
import "../components/sponsorships/style.scss";

export type SponsorshipSectionSkeletonProps = {
    /** Match `SponsorshipCampaignCard` early-access height (255px) vs default (221px). */
    cardVariant?: "default" | "early-access";
    /** Number of placeholder cards in the horizontal row. */
    cardCount?: number;
};

const SponsorshipSectionSkeleton: React.FC<SponsorshipSectionSkeletonProps> = ({
    cardVariant = "default",
    cardCount = 3,
}) => {
    const cardHeight = cardVariant === "early-access" ? 255 : 221;
    const scrollClass =
        cardVariant === "early-access"
            ? "sponsorship-cards-scroll sponsorship-cards-scroll--early-access"
            : "sponsorship-cards-scroll";

    return (
        <section className="sponsorship-section" aria-busy="true" aria-label="Loading campaigns">
            <Skeleton width={160} height={14} borderRadius={4} />
            <div className={scrollClass}>
                {Array.from({ length: cardCount }).map((_, i) => (
                    <div key={i} className="sponsorship-section-skeleton-card">
                        <Skeleton height={cardHeight} borderRadius={20} containerClassName="sponsorship-section-skeleton-inner" />
                    </div>
                ))}
            </div>
        </section>
    );
};

export default SponsorshipSectionSkeleton;
